import type { SiteProfile } from './types';
import { wognumProfile } from './wognum';

const demoSolarProfile: number[][] = wognumProfile.solarProfile.map(month =>
  month.map(v => Math.round(v * 0.227 * 10) / 10)
);

export const demoProfile: SiteProfile = {
  id: 'demo',
  name: 'Energy Park Configurator',
  company: 'Energy Solutions',
  client: 'Klant',
  logoUrl: undefined,
  clientLogoUrl: undefined,
  password: undefined,
  version: 'v1.3',

  solarProfile: demoSolarProfile,
  solarRefCapacity: 5,
  fleet: [
    { type: "Distributietruck", n: 10, mwh: 2000 },
    { type: "Stadsbezorger", n: 6, mwh: 1200 },
    { type: "Trekker regionaal", n: 4, mwh: 1800 },
  ],
  chargingProfile: [
    0.08, 0.07, 0.06, 0.05, 0.04, 0.03,
    0.02, 0.01, 0.01, 0.01, 0.01, 0.01,
    0.01, 0.01, 0.01, 0.01, 0.02, 0.02,
    0.03, 0.04, 0.06, 0.08, 0.10, 0.10,
  ],
  seasonalFactors: [
    0.95, 0.93, 0.97, 1.00, 1.02, 1.00,
    0.98, 0.96, 1.01, 1.04, 1.06, 1.08,
  ],

  defaults: {
    pv: 5, bE: 8, bP: 4,
    eff: 88, dod: 90, buP: 1,
    gMax: 0.5, dem: 5000, deg: 2,
  },

  scenarios: [
    { n: 'Standaard', d: 'Standaard configuratie', v: { pv:5,bE:8,bP:4,eff:88,dod:90,buP:1,gMax:0.5,dem:5000,deg:2,projYear:1 } },
    { n: '3 MWp', d: 'Kleinere PV-installatie', v: { pv:3,bE:8,bP:4,eff:88,dod:90,buP:1,gMax:0.5,dem:5000,deg:2,projYear:1 } },
    { n: 'Geen Backup', d: 'Zonder noodgenerator', v: { pv:5,bE:8,bP:4,eff:88,dod:90,buP:0,gMax:0.5,dem:5000,deg:2,projYear:1 } },
    { n: 'Grote BESS', d: 'Dubbele batterijcapaciteit', v: { pv:5,bE:16,bP:4,eff:88,dod:90,buP:1,gMax:0.5,dem:5000,deg:2,projYear:1 } },
    { n: 'Jaar 10', d: 'Na 10 jaar degradatie (2%/j)', v: { pv:5,bE:8,bP:4,eff:88,dod:90,buP:1,gMax:0.5,dem:5000,deg:2,projYear:10 } },
    { n: 'Jaar 20', d: 'Einde levensduur (20 jaar)', v: { pv:5,bE:8,bP:4,eff:88,dod:90,buP:1,gMax:0.5,dem:5000,deg:2,projYear:20 } },
  ],

  docs: [
    { cat: "BESS", params: [
      { l: "Round-trip Efficiency", d: "88%", r: "82-95%", s: "BloombergNEF 2024; NREL (2024).", n: "LFP standaard." },
      { l: "Depth of Discharge", d: "90%", r: "80-95%", s: "NREL (2024).", n: "90% DoD." },
    ]},
    { cat: "Grid", params: [
      { l: "Capaciteit", d: "0.5 MW", r: "0-5 MW", s: "Configureerbaar.", n: "Symmetrisch." },
    ]},
    { cat: "PV", params: [
      { l: "Capaciteit", d: "5 MWp", r: "0.5-40 MWp", s: "Configureerbaar.", n: "Synthetisch profiel." },
    ]},
  ],

  guide: [
    {
      title: "Wat is dit model?",
      icon: "🏗️",
      body: `Dit is een **simulatiemodel** voor een energiepark. Het berekent hoeveel energie er per uur wordt opgewekt door zonnepanelen, hoeveel er nodig is om de elektrische vloot op te laden, en hoe een batterij, het stroomnet en een noodgenerator samenwerken.`
    },
  ],

  neutralNames: {
    company: 'Energy Solutions',
    client: 'de klant',
    projectName: 'Energy Park',
  },
};
